import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function TermsPage() {
  const lastUpdated = "12 Maggio 2025";

  return (
    <>
      <Helmet>
        <title>Termini e Condizioni | Rarifex</title>
        <meta name="description" content="Termini e condizioni di utilizzo di Rarifex. Leggi le condizioni che regolano l'uso della piattaforma e l'acquisto di prodotti artigianali." />
        <link rel="canonical" href="https://www.rarifex.com/termini" />
      </Helmet>

      <div className="min-h-screen bg-white">
        <div className="container mx-auto px-4 py-12 md:py-16">
          <div className="max-w-4xl mx-auto">
            
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Termini e Condizioni di Utilizzo
            </h1>
            <p className="text-slate-500 mb-8">
              Ultimo aggiornamento: {lastUpdated}
            </p>

            <div className="prose prose-slate max-w-none">
              
              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Definizioni</h2>
                <p className="text-slate-700 mb-4">
                  Ai fini delle presenti Condizioni Generali, si intende per:
                </p>
                <ul className="list-disc pl-6 text-slate-700 space-y-2">
                  <li><strong>"Piattaforma":</strong> il sito web rarifex.com e le relative applicazioni</li>
                  <li><strong>"Rarifex":</strong> Rarifex S.r.l., gestore della Piattaforma</li>
                  <li><strong>"Utente":</strong> qualsiasi persona fisica o giuridica che accede alla Piattaforma</li>
                  <li><strong>"Cliente":</strong> l'Utente che acquista prodotti tramite la Piattaforma</li>
                  <li><strong>"Artigiano" o "Venditore":</strong> l'Utente che vende prodotti tramite la Piattaforma</li>
                  <li><strong>"Prodotto":</strong> qualsiasi bene offerto in vendita sulla Piattaforma</li>
                  <li><strong>"Ordine":</strong> la proposta di acquisto effettuata dal Cliente</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Oggetto e Accettazione</h2>
                <p className="text-slate-700 mb-4">
                  2.1. Le presenti Condizioni Generali disciplinano l'utilizzo della Piattaforma e i contratti di 
                  compravendita conclusi tra Clienti e Artigiani tramite la Piattaforma.
                </p>
                <p className="text-slate-700 mb-4">
                  2.2. L'utilizzo della Piattaforma e/o la registrazione comportano l'accettazione integrale delle 
                  presenti Condizioni Generali. L'Utente che non intende accettare le presenti condizioni non deve 
                  utilizzare la Piattaforma.
                </p>
                <p className="text-slate-700">
                  2.3. Rarifex si riserva il diritto di modificare le presenti Condizioni Generali in qualsiasi momento. 
                  Le modifiche saranno efficaci dalla data di pubblicazione sulla Piattaforma.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Ruolo di Rarifex</h2>
                <p className="text-slate-700 mb-4">
                  3.1. Rarifex opera come intermediario tecnologico che mette in contatto Clienti e Artigiani. 
                  Rarifex non è parte del contratto di compravendita concluso tra Cliente e Artigiano.
                </p>
                <p className="text-slate-700 mb-4">
                  3.2. Rarifex non è proprietaria dei Prodotti venduti sulla Piattaforma e non garantisce la qualità, 
                  sicurezza o legalità dei Prodotti, né la veridicità delle informazioni pubblicate dagli Artigiani.
                </p>
                <p className="text-slate-700">
                  3.3. Rarifex fornisce un sistema di pagamento sicuro tramite Stripe e trattiene i fondi fino alla 
                  conferma di ricezione da parte del Cliente, al fine di tutelare entrambe le parti.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Registrazione</h2>
                <p className="text-slate-700 mb-4">
                  4.1. Per effettuare acquisti o vendere sulla Piattaforma è necessario creare un account. 
                  L'Utente garantisce che le informazioni fornite sono veritiere, accurate e complete.
                </p>
                <p className="text-slate-700 mb-4">
                  4.2. L'Utente è responsabile della riservatezza delle proprie credenziali di accesso e di tutte 
                  le attività svolte tramite il proprio account.
                </p>
                <p className="text-slate-700 mb-4">
                  4.3. Rarifex si riserva il diritto di sospendere o chiudere account in caso di violazione delle 
                  presenti Condizioni Generali o comportamenti fraudolenti.
                </p>
                <p className="text-slate-700">
                  4.4. Gli Artigiani devono fornire informazioni aggiuntive per la verifica dell'identità e, 
                  ove applicabile, della partita IVA.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Processo di Acquisto</h2>
                <p className="text-slate-700 mb-4">
                  5.1. Il Cliente può aggiungere Prodotti al carrello e procedere al checkout. L'invio dell'Ordine 
                  costituisce una proposta di acquisto vincolante per il Cliente.
                </p>
                <p className="text-slate-700 mb-4">
                  5.2. Il contratto di vendita si perfeziona quando l'Artigiano accetta l'Ordine, salvo indisponibilità 
                  del Prodotto comunicata entro 48 ore.
                </p>
                <p className="text-slate-700 mb-4">
                  5.3. I prezzi indicati sulla Piattaforma sono comprensivi di IVA ove applicabile. Le spese di 
                  spedizione sono indicate separatamente prima del completamento dell'Ordine.
                </p>
                <p className="text-slate-700">
                  5.4. Il pagamento avviene tramite i metodi disponibili sulla Piattaforma (carte di credito/debito, 
                  Apple Pay, Google Pay, bonifico SEPA). I fondi sono trattenuti da Stripe fino alla conferma di 
                  ricezione da parte del Cliente.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Prodotti Personalizzati</h2>
                <p className="text-slate-700 mb-4">
                  6.1. Il Cliente può richiedere la realizzazione di Prodotti personalizzati tramite la funzione 
                  "Richieste Personalizzate". Gli Artigiani interessati invieranno proposte con prezzo e tempistiche.
                </p>
                <p className="text-slate-700 mb-4">
                  6.2. L'accettazione di una proposta da parte del Cliente costituisce un contratto vincolante. 
                  Una volta accettata la proposta e iniziata la lavorazione, non è possibile annullare l'Ordine.
                </p>
                <p className="text-slate-700">
                  6.3. Ai sensi dell'art. 59, comma 1, lettera c) del Codice del Consumo (D.Lgs. 206/2005), il diritto 
                  di recesso non si applica ai prodotti confezionati su misura o chiaramente personalizzati.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Spedizione e Consegna</h2>
                <p className="text-slate-700 mb-4">
                  7.1. L'Artigiano è responsabile dell'imballaggio e della spedizione dei Prodotti. I tempi e i costi 
                  di spedizione sono indicati nella scheda prodotto e confermati prima del checkout.
                </p>
                <p className="text-slate-700 mb-4">
                  7.2. L'Artigiano deve fornire un codice di tracking valido e comunicarlo al Cliente tramite la Piattaforma.
                </p>
                <p className="text-slate-700 mb-4">
                  7.3. Il rischio di perdita o danneggiamento dei Prodotti passa al Cliente al momento della consegna 
                  al corriere da parte dell'Artigiano.
                </p>
                <p className="text-slate-700">
                  7.4. Il Cliente deve verificare l'integrità del pacco alla consegna e segnalare eventuali danni 
                  immediatamente al corriere e all'Artigiano.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Conferma di Ricezione e Pagamento</h2>
                <p className="text-slate-700 mb-4">
                  8.1. Dopo la consegna, il Cliente ha 7 giorni per confermare la ricezione del Prodotto o aprire 
                  una contestazione in caso di problemi.
                </p>
                <p className="text-slate-700 mb-4">
                  8.2. La conferma di ricezione (esplicita o automatica dopo 7 giorni) comporta il rilascio del 
                  pagamento all'Artigiano.
                </p>
                <p className="text-slate-700">
                  8.3. In caso di contestazione, i fondi restano trattenuti fino alla risoluzione della controversia.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Diritto di Recesso</h2>
                <p className="text-slate-700 mb-4">
                  9.1. Ai sensi degli artt. 52 e ss. del Codice del Consumo, il Cliente consumatore ha diritto di 
                  recedere dal contratto entro 14 giorni dalla ricezione del Prodotto, senza dover fornire alcuna motivazione.
                </p>
                <p className="text-slate-700 mb-4">
                  9.2. Il diritto di recesso NON si applica a:
                </p>
                <ul className="list-disc pl-6 text-slate-700 space-y-2">
                  <li>Prodotti confezionati su misura o chiaramente personalizzati</li>
                  <li>Prodotti sigillati che non si prestano a essere restituiti per motivi igienici e che sono stati aperti dopo la consegna</li>
                  <li>Prodotti che rischiano di deteriorarsi o scadere rapidamente</li>
                </ul>
                <p className="text-slate-700 mt-4">
                  9.3. Per esercitare il recesso, il Cliente deve comunicare la propria decisione all'Artigiano e 
                  restituire il Prodotto entro 14 giorni. Le spese di restituzione sono a carico del Cliente, salvo 
                  diverso accordo con l'Artigiano.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">10. Garanzia Legale</h2>
                <p className="text-slate-700 mb-4">
                  10.1. Ai sensi degli artt. 128 e ss. del Codice del Consumo, l'Artigiano è responsabile nei confronti 
                  del Cliente consumatore per qualsiasi difetto di conformità esistente al momento della consegna e 
                  che si manifesti entro 2 anni dalla stessa.
                </p>
                <p className="text-slate-700 mb-4">
                  10.2. In caso di difetto di conformità, il Cliente ha diritto al ripristino della conformità 
                  (riparazione o sostituzione) o, in subordine, alla riduzione del prezzo o alla risoluzione del contratto.
                </p>
                <p className="text-slate-700">
                  10.3. Il Cliente deve denunciare il difetto all'Artigiano entro 2 mesi dalla scoperta.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">11. Obblighi degli Artigiani</h2>
                <p className="text-slate-700 mb-4">
                  11.1. L'Artigiano garantisce di essere legittimato a vendere i Prodotti e che gli stessi non 
                  violano diritti di terzi (proprietà intellettuale, marchi, brevetti).
                </p>
                <p className="text-slate-700 mb-4">
                  11.2. L'Artigiano è responsabile della veridicità e completezza delle informazioni sui Prodotti 
                  (descrizione, materiali, dimensioni, foto).
                </p>
                <p className="text-slate-700 mb-4">
                  11.3. L'Artigiano si impegna a rispettare tutte le normative applicabili (sicurezza prodotti, 
                  etichettatura, norme fiscali).
                </p>
                <p className="text-slate-700">
                  11.4. L'Artigiano è tenuto a evadere gli ordini nei tempi indicati e a comunicare tempestivamente 
                  eventuali ritardi o impossibilità.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">12. Commissioni</h2>
                <p className="text-slate-700 mb-4">
                  12.1. Rarifex trattiene una commissione su ogni vendita completata. L'importo della commissione 
                  è indicato nell'area riservata agli Artigiani e può variare in base al piano sottoscritto.
                </p>
                <p className="text-slate-700">
                  12.2. Rarifex si riserva il diritto di modificare le commissioni con preavviso di 30 giorni.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">13. Proprietà Intellettuale</h2>
                <p className="text-slate-700 mb-4">
                  13.1. Tutti i contenuti della Piattaforma (testi, grafica, loghi, software) sono di proprietà di 
                  Rarifex o dei rispettivi titolari e sono protetti dalle leggi sulla proprietà intellettuale.
                </p>
                <p className="text-slate-700">
                  13.2. L'Utente che pubblica contenuti sulla Piattaforma (foto, descrizioni, recensioni) concede 
                  a Rarifex una licenza non esclusiva per utilizzare tali contenuti ai fini del funzionamento della Piattaforma.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">14. Limitazione di Responsabilità</h2>
                <p className="text-slate-700 mb-4">
                  14.1. Rarifex non è responsabile per danni derivanti da: (a) condotta degli Utenti; (b) qualità, 
                  sicurezza o legalità dei Prodotti; (c) inadempimenti degli Artigiani; (d) interruzioni del servizio 
                  dovute a cause di forza maggiore.
                </p>
                <p className="text-slate-700">
                  14.2. La responsabilità di Rarifex, ove applicabile, è limitata all'importo delle commissioni 
                  percepite in relazione alla transazione oggetto di contestazione.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">15. Risoluzione delle Controversie</h2>
                <p className="text-slate-700 mb-4">
                  15.1. In caso di controversia tra Cliente e Artigiano, le parti sono invitate a tentare una 
                  risoluzione amichevole. Rarifex può intervenire come mediatore su richiesta delle parti.
                </p>
                <p className="text-slate-700 mb-4">
                  15.2. Il Cliente consumatore può ricorrere alla piattaforma ODR (Online Dispute Resolution) 
                  dell'Unione Europea: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-shop-primary hover:underline">https://ec.europa.eu/consumers/odr</a>
                </p>
                <p className="text-slate-700">
                  15.3. Per le controversie non risolte in via amichevole, è competente il Foro del luogo di 
                  residenza del Cliente consumatore. Per i Clienti professionisti, è competente il Foro di Milano.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">16. Legge Applicabile</h2>
                <p className="text-slate-700">
                  Le presenti Condizioni Generali sono regolate dalla legge italiana. Per i Clienti consumatori 
                  residenti nell'Unione Europea, si applicano le disposizioni imperative della legge del paese di residenza.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-4">17. Contatti</h2>
                <p className="text-slate-700">
                  Per qualsiasi domanda relativa alle presenti Condizioni Generali:
                </p>
                <ul className="list-none pl-0 text-slate-700 mt-4 space-y-1">
                  <li><strong>Email:</strong> <a href="mailto:info@rarifex.com" className="text-shop-primary hover:underline">info@rarifex.com</a></li>
                </ul>
              </section>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
